import { capitalizeFirst, isString } from '../../../utils';
import { ADDRESS_FIELDS_TO_VALIDATE, STATE } from './constants';

var prefixString = (str, prefix) => {
  return isString(prefix) ? "".concat(prefix).concat(capitalizeFirst(str)) : str;
};

var getLabel = (base, optional, isRequired) => {
  if (!isString(optional)) {
    return base;
  }

  return isRequired ? base : "".concat(base, " ").concat(optional);
};

var isStateFieldInput = (fieldName, selectOptions) => {
  return fieldName === STATE && !Array.isArray(selectOptions);
};

var shouldValidateAddressField = (fieldName, selectOptions, disallowUnsupportedCharacters) => {
  if (!disallowUnsupportedCharacters) {
    return false;
  }

  return ADDRESS_FIELDS_TO_VALIDATE.includes(fieldName) || isStateFieldInput(fieldName, selectOptions);
};

export { getLabel, isStateFieldInput, prefixString, shouldValidateAddressField };